import { Box, Typography } from "@mui/material"
import React from "react"

/**
 * Props for the TabPanel component
 */
interface TabPanelProps {
  children: React.ReactNode
  value: number
  index: number
  [key: string]: any
}

/**
 * TabPanel component for displaying tab content
 * Provides accessibility attributes and conditional rendering
 */
export function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}